import { render, staticRenderFns } from "./LimitlessButton.vue?vue&type=template&id=62d199aa&scoped=true&"
import script from "./LimitlessButton.vue?vue&type=script&lang=js&"
export * from "./LimitlessButton.vue?vue&type=script&lang=js&"
import style0 from "./LimitlessButton.vue?vue&type=style&index=0&id=62d199aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d199aa",
  null
  
)

export default component.exports